import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../lib/i18n';
import { useKitchenPause } from '../../lib/kitchen-pause-context';
export function KitchenPausedBanner() {
  const {
    t
  } = useLanguage();
  const {
    isKitchenPaused,
    monitoredRestaurantId
  } = useKitchenPause();
  // Only render when actively monitoring a restaurant AND kitchen is paused
  if (!isKitchenPaused || !monitoredRestaurantId) return null;
  return <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-3" data-id="element-2525" data-mp="2c4odireh8kn">
      <div className="max-w-5xl mx-auto flex items-start sm:items-center gap-3" data-id="element-2526" data-mp="3udt4c5g2hpwt">
        <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5 sm:mt-0" data-id="element-2527" data-mp="3pepywjw6dhob" />
        <div data-id="element-2528" data-mp="3kgy33esetbeu">
          <h3 className="text-sm font-bold text-amber-500" data-id="element-2529" data-mp="3khg9v5cp7810">
            {t('kitchen_paused')}
          </h3>
          <p className="text-sm text-amber-500/80 mt-0.5" data-id="element-2530" data-mp="1nmtlf4qg5xqw">
            {t('kitchen_paused_msg')}
          </p>
        </div>
      </div>
    </div>;
}